import {
  CountryCode,
  CurrencyCode,
  DISPLAY_PLACEHOLDER,
  LocaleCode,
} from "constants/enums";

export { DISPLAY_PLACEHOLDER };

export const getLocaleForCountryCode = (countryCode) =>
  countryCode === CountryCode.IND ? LocaleCode.EN_IN : LocaleCode.EN_US;

export const getLocaleForCurrencyCode = (currencyCode) =>
  currencyCode === CurrencyCode.INR ? LocaleCode.EN_IN : LocaleCode.EN_US;

export const getOrderCurrencyCode = (order) => order?.currency?.name;

export const getOrderPendingAmount = (order) => {
  if (!order) {
    return 0;
  }

  if (order.pending_amount != null) {
    return Number(order.pending_amount) || 0;
  }

  if (order.amount_paid != null) {
    return (Number(order.amount) || 0) - (Number(order.amount_paid) || 0);
  }

  return (
    (Number(order.inr_conversion_amount) || 0) -
    (Number(order.inr_conversion_amount_paid) || 0)
  );
};
